import { Box } from '@mui/material';
import React from 'react';
import CommonComprehensiveFooter from './CommonComprehensiveFooter';
import CommonContactForm from './CommonContactForm';
import CommonWhatsAppCTA from './CommonWhatsAppCTA';

const CommonFooter: React.FC = () => {
    return (
        <Box>
            <CommonContactForm />
            <CommonWhatsAppCTA />
            <CommonComprehensiveFooter />
        </Box>
    );
};

export default CommonFooter;
